export default {
    ancientOffer: 'ancientOffer/testResult'
};
